import { TThemeActions, ThemeActionTypes } from './actions';

interface IThemeState {
  isDarkMode: boolean;
}

const initialState: IThemeState = {
  isDarkMode: false,
};

export const themeReducer = (state = initialState, action: TThemeActions): IThemeState => {
  switch (action.type) {
    case ThemeActionTypes.IS_DARK_MODE:
      return { ...state, isDarkMode: action.payload };
    default:
      return state;
  }
};
